import React, { useState } from 'react';
import StoreRequestPopup from './StoreRequestPopup';
import './Packages.css';
import {
  MdOutlineStar,
  MdShoppingCart,
  MdCreditCard,
  MdMessage,
  MdPhoneAndroid,
  MdDescription,
  MdLocalOffer
} from 'react-icons/md';
import { FiCheck, FiArrowRight, FiPlus } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';

const Packages = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleGetStartedClick = () => {
    setIsPopupOpen(true);
  };

  const handleViewAddOnsClick = () => {
    // You can implement add-ons modal or scroll to add-ons section here
    console.log('View Add-Ons clicked');
  };

  return (
    <>
      <section className="packages-section">
        <div className="packages-bg-blur"></div>

        <div className="packages-container">
          {/* Header */}
          <div className="packages-header">
            <div className="packages-badge">
              <MdOutlineStar size={11} />
              <span>Pricing</span>
            </div>
            <h2 className="packages-title">
              Simple Pricing. <span className="text-gradient">No Confusion.</span>
            </h2>
            <p className="packages-subtitle">
              Start with one standard website package made for small e-commerce businesses.
            </p>
          </div>

          {/* Floating Icons */}
          <div className="social-icons">
            <div className="social-icon social-icon-1">
              <MdShoppingCart size={30} />
            </div>
            <div className="social-icon social-icon-2">
              <MdCreditCard size={30} />
            </div>
            <div className="social-icon social-icon-3 social-icon-whatsapp">
              <FaWhatsapp size={30} />
            </div>
            <div className="social-icon social-icon-4">
              <MdPhoneAndroid size={30} />
            </div>
            <div className="social-icon social-icon-5">
              <MdDescription size={30} />
            </div>
            <div className="social-icon social-icon-6">
              <MdLocalOffer size={30} />
            </div>
          </div>

          {/* Pricing Card */}
          <div className="pricing-card-wrapper">
            <div className="pricing-card-glow"></div>
            <div className="pricing-card">

              <div className="pricing-card-content">
                <div className="pricing-card-bg-blur-1"></div>
                <div className="pricing-card-bg-blur-2"></div>
                {/* Badge and Title */}
                <div className="card-badge">
                  <MdOutlineStar size={11} />
                  <span>Store Launch Kit</span>
                </div>
                <div className="card-header">
                  <h3 className="card-title">Standard E-commerce Package</h3>
                </div>
                <div className="card-paragraph">
                  <p className="card-subtitle">Everything to launch your branded online store.</p>
                </div>

                {/* Pricing Grid */}
                <div className="pricing-grid">
                  <div className="pricing-box">
                    <p className="pricing-label">One-Time Setup</p>
                    <p className="pricing-amount">PKR XX,XXX</p>
                    <p className="pricing-note">Pay once to launch</p>
                  </div>
                  <div className="pricing-box featured">
                    <p className="pricing-label">Monthly Subscription</p>
                    <p className="pricing-amount">
                      PKR X,XXX<span className="pricing-period">/mo</span>
                    </p>
                    <p className="pricing-note">Hosting · Support · Maintenance</p>
                  </div>
                </div>

                {/* Features List */}
                <div className="features-grid">
                  <div className="feature-item">
                    <span className="feature-check"><FiCheck size={12} strokeWidth={3} /></span>
                    <span>Up to 25 products</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-check"><FiCheck size={12} strokeWidth={3} /></span>
                    <span>Up to 4 main categories</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-check"><FiCheck size={12} strokeWidth={3} /></span>
                    <span>Up to 3 variants per product</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-check"><FiCheck size={12} strokeWidth={3} /></span>
                    <span>Up to 5 product images per product</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-check"><FiCheck size={12} strokeWidth={3} /></span>
                    <span>3 client-provided homepage banners</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-check"><FiCheck size={12} strokeWidth={3} /></span>
                    <span>Standard homepage structure</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-check"><FiCheck size={12} strokeWidth={3} /></span>
                    <span>Standard product page structure</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-check"><FiCheck size={12} strokeWidth={3} /></span>
                    <span>Standard checkout flow</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-check"><FiCheck size={12} strokeWidth={3} /></span>
                    <span>Mobile-first design</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-check"><FiCheck size={12} strokeWidth={3} /></span>
                    <span>WhatsApp support</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-check"><FiCheck size={12} strokeWidth={3} /></span>
                    <span>COD + online payment support</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-check"><FiCheck size={12} strokeWidth={3} /></span>
                    <span>Essential policy pages</span>
                  </div>
                </div>

                {/* Footer Note */}
                <p className="addons-note">Extra features are available as paid add-ons.</p>

                {/* Buttons */}
                <div className="button-group">
                  <button className="btn-primary" onClick={handleGetStartedClick}>
                    Get Started
                    <FiArrowRight size={18} className="btn-icon" />
                  </button>
                  <button className="btn-secondary" onClick={handleViewAddOnsClick}>
                    <FiPlus size={16} className="btn-icon" />
                    View Add-Ons
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Store Request Popup */}
      <StoreRequestPopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
    </>
  );
};

export default Packages;